import { AnyAppEvent, AppEvent } from "../appEvent.types";

const eventName = "add-exponents-to-event" as const;

export type AddExponentsToEventEventData = {
  eventId: string;
  structureConnectEventsIds?: string[];
  structureIds?: string[];
};
export type AddExponentsToEventEvent = AppEvent<
  typeof eventName,
  AddExponentsToEventEventData
>;

export const isAddExponentsToEventEvent = (
  event: AnyAppEvent
): event is AddExponentsToEventEvent => event.name === eventName;

export { eventName as addExponentsToEvent };
